import { VHCRecordLogInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type CreateRecordInput = {
  requestBody?: VHCRecordLogInput;
};

export const useCreateRecordMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecords, CreateRecordInput>
) =>
  useMutationWithNotifications(
    ({ requestBody }: CreateRecordInput) => VhcRecordLogService.postVhcRecords(requestBody),
    options,
    {
      successMessage: 'Record created successfully!',
      enableToast: true
    }
  );
